// @ts-ignore
import { draftId } from './index'
// @ts-ignore
import { NavLink, LinkType } from '../../types/Link'
import { ListStateToProps, State } from '../../types/List'
// @ts-ignore
import ListItem from '../chauffeurs/docs.ListItem'

interface ExtraProps<T> {
  addItemLink?: ListStateToProps<T>['addItemLink']
  emptyListImage?: ListStateToProps<T>['emptyListImage']
  emptyListImageAltText?: ListStateToProps<T>['emptyListImageAltText']
  itemComponent?: typeof ListItem
  keyPrefix: ListStateToProps<T>['keyPrefix']
  listPage?: LinkType
  resourceId?: string
  tableHeaders: ListStateToProps<T>['tableHeaders']
  disableBackButton?: boolean
}

export default function mapListStateToProps<T> (
  state: State<T>,
  extras: ExtraProps<T>,
  tabs?: NavLink[]
): ListStateToProps<T> {
  const items = Object.entries(state.data).filter(([item]) => item !== draftId)
  return {
    allowedFilters: state.allowedFilters,
    allowedUIFilters: state.allowedUIFilters,
    defaultFilter: state.defaultFilter,
    filter: state.filter,
    isFetchingList: state.isFetchingList,
    items,
    lastUpdate: state.lastUpdate,
    pagination: state.pagination,
    recordCount: state.recordCount,
    tabs: tabs || [],
    ...extras
  }
}
